'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TopicColors = {
  black: { title: 'Black', hotkey: 'Ctrl+Meta+1' },
  grey: { title: 'Grey', hotkey: 'Ctrl+Meta+2' },
  darkgrey: { title: 'Dark Grey', hotkey: 'Ctrl+Meta+3' },
  red: { title: 'Red', hotkey: 'Ctrl+Meta+4' },
  yellow: { title: 'Yellow', hotkey: 'Ctrl+Meta+5' },
  blue: { title: 'Blue', hotkey: 'Ctrl+Meta+6' },
  male: { title: 'Male', hotkey: 'Ctrl+Meta+7' },
  female: { title: 'Female', hotkey: 'Ctrl+Meta+8' },
  neuter: { title: 'Neuter', hotkey: 'Ctrl+Meta+9' },
  dative: { title: 'Dative', hotkey: 'Ctrl+Meta+0' },
  accusative: { title: 'Accusative', hotkey: 'Ctrl+Meta+-' }
};

exports.default = TopicColors;